/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailSettingsInput } from '../../models/email-settings-input';

export interface UpdateEmailSettings$Params {
  tenantId: string;
  'Active-Tenant-Identifier': string;
      body: EmailSettingsInput
}

export function updateEmailSettings(http: HttpClient, rootUrl: string, params: UpdateEmailSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateEmailSettings.PATH, 'put');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateEmailSettings.PATH = '/tenants/{tenantId}/email-settings';
